import { get } from 'stash/utils';
import { createSelector } from 'reselect';
import { userSelector } from './user';
import { pxQuestionsAnswerTypes } from 'stash/components/screens/state-zero-home/constants';

export const applicationSelector = (state) => get(state, 'application', {});

export const setScheduleSelector = createSelector(
	applicationSelector,
	(application) => application.setSchedule
);

export const applicationSignUpSelector = createSelector(
	applicationSelector,
	(application) => get(application, 'signUp', {})
);

export const completedScreenSelector = (screen) =>
	createSelector(applicationSelector, (state) => state[screen]);

export const applicationOneTimeTransferSelector = createSelector(
	applicationSignUpSelector,
	(data) => get(data, 'oneTimeTransfer', {})
);

export const accountOneTimeTransferSelector = createSelector(
	applicationOneTimeTransferSelector,
	(data) => {
		const { frequency, amount } = data;
		return {
			frequency,
			amount,
			title: 'Stash banking account',
		};
	}
);

export const isTransferConfirmedSelector = createSelector(
	[applicationSignUpSelector, userSelector],
	(signUpData, user) => {
		return (
			signUpData.completed['one-time-transfer-confirm'] ||
			!!get(user, 'stash_bank_plastic_deposits.amount')
		);
	}
);

export const oAuthRedirectURISelector = createSelector(
	applicationSelector,
	(data) => data.linkBank.oauth.redirectUri
);

export const bankLinkDrawerModalViewSelector = createSelector(
	applicationSelector,
	(data) => data.linkBank.BankLinkDrawerModalProps.view
);

export const isBankLinkDrawerModalOpenSelector = createSelector(
	applicationSelector,
	(data) => data.linkBank.BankLinkDrawerModalProps.isOpen
);

export const userTestAssigment = createSelector(applicationSelector, (state) =>
	get(state, 'testAssignment', {})
);

export const getUserStateZeroSelection = createSelector(
	applicationSelector,
	(application) => {
		return application.eSig.eSigNextStep || false;
	}
);

export const getPersonalPortfolioFlowDataSelector = createSelector(
	applicationSelector,
	(application) => {
		return application.eSig.personalPortfolioFlowData || false;
	}
);

export const getIdvStatusSelector = createSelector(applicationSelector, (application) => {
	return application.idvStatus || false;
});

export const getOriginalAccountEmailSelector = createSelector(
	applicationSelector,
	(application) => {
		return application.ssn?.duplicateAccount?.originalAccountMaskedEmail || undefined;
	}
);

export const getEntitlementFlagsSelector = createSelector(
	applicationSelector,
	(application) => {
		return application?.signUp?.entitlementFlags || undefined;
	}
);

export const hasPersonalEntitlementSelector = createSelector(
	applicationSelector,
	(application) => {
		return application?.signUp?.entitlementFlags?.hasPersonalEnititlement || false;
	}
);

export const hasSmartEntitlementSelector = createSelector(
	applicationSelector,
	(application) => {
		return application?.signUp?.entitlementFlags?.hasSmartEntitlement || false;
	}
);

export const hasBankEntitlementSelector = createSelector(
	applicationSelector,
	(application) => {
		return application?.signUp?.entitlementFlags?.hasBankEntitlement || false;
	}
);

export const hasNextStepAsPersonalBrokerageSelector = createSelector(
	applicationSelector,
	(application) => {
		return (
			application.eSig.eSigNextStep === pxQuestionsAnswerTypes.PERSONAL_BROKERAGE_ACCOUNT
		);
	}
);
